import {h, Component} from "preact";
import {route} from "preact-router";
import Ticket from "../utils/ticket-logic.jsx";

import * as P from "../mobile-templates/tournament.jsx";

export default class PrematchEventPreview extends Component {
	getLocalEventDate(event) {
		return new Date(event.date * 1000).toLocaleString();
	}
	marketsOrder(displayRule, markets) { // [{id, order}, ...]
		const result = {};
		displayRule.forEach((rule, idx) => {
			const [marketId, outcomeId] = rule.id.split('.');
			result[marketId] = result[marketId] || {
				id: marketId,
				order: idx,
				name: markets.sub ? markets.sub[marketId].name : markets.name,
				sub: []
			}
			result[marketId].sub.push({
				id: outcomeId,
				name: rule.name
			})
		});
		const sortedMarkets = Object.values(result).sort((a, b) => a.order - b.order);
		return sortedMarkets;
	}
	getFakeMarket(marketId, eventId, mockMarket) {
		return {
			id: `/market/${eventId}/${marketId}`,
			name: mockMarket.name,
			legatura: '',
			handicap: false,
			sub: mockMarket.sub.map(outcome => ({
				id: `/outcome/${eventId}/${marketId}/${outcome.id}`, 
				name: outcome.name, 
				value: 0
			})).reduce((sub, outcome) => {
				sub[outcome.id] = outcome;
				return sub;
			}, {})
		};
	}
	getMarkets(event, tournamentCard) {
		const eventId = event.id.split('/')[2];
		const divisible = tournamentCard.market.divisible;
		const markets = this.marketsOrder(tournamentCard.displayRule, tournamentCard.market);
		return markets.map(market => {
			if (divisible)
				return event.sub[`/market/${eventId}/${market.id}`];
			return event.sub[`/market/${eventId}/${market.id}`] || this.getFakeMarket(market.id, eventId, market)
		}).filter(market => {
			return !!market;
		});
	}
	render({tournament, event, tournamentCard}) {
		return <P.EventCard>
			<P.EventInfoRow onClick={() => route("/prematch/"+tournament.id.split('/').slice(2).join('/')+'/'+event.id.split('/').slice(2).join('/'))}>
				<P.EventTeams>
					<P.TeamHolder>
						<P.TeamSymbol side="home" url={""} />
						<P.TeamName>{event.home}</P.TeamName>
					</P.TeamHolder>
					<P.TeamHolder>
						<P.TeamName>{event.away}</P.TeamName>
						<P.TeamSymbol side="away" url={""} />
					</P.TeamHolder>
				</P.EventTeams>
				<P.EventFullDate>{this.getLocalEventDate(event)}</P.EventFullDate>
			</P.EventInfoRow>
			<P.MatchMarkets>
				{this.getMarkets(event, tournamentCard).map(market => <P.MarketContainer>
					<P.MarketTitle>{market.name}</P.MarketTitle>
					<P.OddButtonsGrid cols={Object.keys(market.sub).length}>
						{Object.values(market.sub).map(odd => 
						<P.OddButtonFull
								value={odd.value} 
								onClick={() => Ticket.togglePrematchOdds(odd.id)} 
								selected={Ticket.hasPrematchOdds(odd.id)}>
							<P.OddName>{odd.name}</P.OddName>
							<P.OddValue 
								selected={Ticket.hasPrematchOdds(odd.id)} 
								value={odd.value} />
						</P.OddButtonFull>)}
					</P.OddButtonsGrid>
				</P.MarketContainer>)}
				<div class="h-2" />
			</P.MatchMarkets>
		</P.EventCard>
	}
}